import React, { useState } from 'react';
import { NavLink, useLocation  } from "react-router-dom";
import './menu-sibar.css'

function MenuSibar () {
    const location = useLocation();

    const [openMenu, setOpenMenu] = useState("");

    const [activeMenu, setActiveMenu] = useState("");

    const toggleMenu = (menuName) => {

    if(openMenu === menuName){
        setOpenMenu("");
        setActiveMenu("");
    }else{
        setOpenMenu(menuName);
        setActiveMenu(menuName);
    }

};

//     const [openAdmin, setOpenAdmin] = useState(false);

//     const [openIndustry, setOpenIndustry] = useState(false);


// const [openIndustrialReport, setOpenIndustrialReport] = useState(false);
// const [openDocument, setOpenDocument] = useState(false);
// const [openElectricity, setOpenElectricity] = useState(false);
// const [openTrade, setOpenTrade] = useState(false);
// const [openFieldSector, setOpenFieldSector] = useState(false)



const [activeMainMenu, setActiveMainMenu] = useState("");

const toggleMainMenu = (menuName) => {
    setActiveMainMenu(
        activeMainMenu === menuName ? "" : menuName
    );
};



const [openSection, setOpenSection] = useState("");

const toggleSection = (section) => {
    setOpenSection(
        openSection === section ? "" : section
    );
};



// Tự động highlight menu Điện lực khi đang ở submenu
const isElectricityActive =
    location.pathname === "/bao-cao-cung-cap-dien" ||
    location.pathname === "/bao-cao-su-co-mat-dien" ||
    location.pathname === "/bao-cao-tiet-kiem-dien" ||
    location.pathname === "/cong-trinh-dien-nong-thon" ||
    location.pathname === "/nang-luong-tai-tao-dien";


// Tự động highlight menu Thương mại khi đang ở submenu    
const isTradeActive =
    location.pathname === "/thuong-mai" ||
    location.pathname === "/bao-cao-cho" ||
    location.pathname === "/bao-cao-sieu-thi" ||
    location.pathname === "/bao-cao-ban-hang-da-cap" ||
    location.pathname === "/bao-cao-xuc-tien-thuong-mai" ||
    location.pathname === "/bao-cao-thuong-mai-dien-tu";

// Tự động highlight menu Công nghiệp khi đang ở submenu  
    const isIndustryActive =
    location.pathname === "/congnghiep" ||
    location.pathname === "/bao-cao-san-xuat" ||
    location.pathname === "/bao-cao-cum-cong-nghiep" ||
    location.pathname === "/bao-cao-khuyen-cong" ||
    location.pathname === "/bao-cao-co-khi";

    // Quản lý lĩnh vực ngành
const isFieldSectorActive =
    location.pathname === "/linh-vuc-nganh" ||
    location.pathname === "/nhom-linh-vuc" ||
    location.pathname === "/danh-muc-linh-vuc";


    // Người dùng
    const isUserActive =
    location.pathname === "/list-user" ||
    location.pathname === "/group-users";

    // Phân quyền
const isRoleActive =
    location.pathname === "/role-groups" ||
    location.pathname === "/role-user";

    // Quản lý vai trò
const isManagementRole =
    location.pathname === "/list-roles" 

    // Danh mục dùng chung
const isCategoryActive =
    location.pathname === "/list-categogy" ||
    location.pathname === "/type-categogy";



    // Quản lý dữ liệu
const isDataActive =
    location.pathname === "/manager-database" ||
    location.pathname === "/dairy-database";



    // tích hợp hệ thống
const isIntegrationActive =
    location.pathname === "/list-integration" ||
    location.pathname === "/add-integration";


    // Nhật ký hệ thống
const isDiaryActive =
    location.pathname === "/data-dairy" ||
    location.pathname === "/action-dairy";



    // Sao lưu dữ liệu
const isBackupActive =
    location.pathname === "/list-backup" ||
    location.pathname === "/new-backup" ||
    location.pathname === "/restore-data";


    
const isConfigActive =
    location.pathname === "/noti-share" ||
    location.pathname === "/cconfig-securyti" ||
    location.pathname === "/config-email" ||
    location.pathname === "/config-show" ||
    location.pathname === "/config-other" ;


// Quản trị hệ thống
const isSystemAdminActive =
    isUserActive ||
    isRoleActive ||
    isManagementRole ||
    isCategoryActive ||
    isDataActive ||
    isIntegrationActive ||
    isDiaryActive ||
    isBackupActive ||
    isConfigActive;







   
        return (
  <div className="sidebar-col-sm-5">

            <div className="sidebar-wrapper">

                <ul className="sidebar-menu-list">

                    {/* Tổng quan */}
                    <li className="sidebar-menu-item">
                        <NavLink
                            to="/dashboard"
                            className={({ isActive }) =>
                                isActive
                                    ? "sidebar-menu-link sidebarMenuLinkActive"
                                    : "sidebar-menu-link"
                            }
                        >
                            <div className="sidebar-menu-left">
                                <i className="fa-solid fa-house sidebar-menu-icon"></i>
                                <span className="sidebar-menu-text">
                                    Tổng quan
                                </span>
                            </div>

                            {/* <i className="fa-solid fa-angle-down sidebar-menu-arrow"></i> */}
                        </NavLink>
                    </li>


{/* KÊ KHAI BÁO CÁO THEO LĨNH VỰC */}

<li
    className="sidebar-menu-title sidebar-section-title"
    onClick={() => toggleSection("report")}
>

    <span>KÊ KHAI, BÁO CÁO THEO LĨNH VỰC</span>

    <i
        className={
            openSection === "report"
                ? "fa-solid fa-angle-down"
                : "fa-solid fa-angle-right"
        }
    ></i>

</li>

{
openSection === "report" && (
<>

{/* Xăng dầu */}
<li className="sidebar-menu-item">
    <NavLink to="/xang-dau" className="sidebar-menu-link">
        <div className="sidebar-menu-left">
            <i className="fa-regular fa-file-lines sidebar-menu-icon"></i>
            <span className="sidebar-menu-text">Xăng dầu</span>
        </div>
    </NavLink>
</li>

{/* Điện lực */}

<li className="sidebar-menu-item">

    <div
        onClick={() => toggleMainMenu("electricity")}
        className={
    activeMainMenu === "electricity" || isElectricityActive
        ? "sidebar-menu-link sidebarMenuLinkActive"
        : "sidebar-menu-link"
}
    >

        <div className="sidebar-menu-left">

            <i className="fa-solid fa-bolt sidebar-menu-icon"></i>

            <span className="sidebar-menu-text">
                Điện lực
            </span>

        </div>

        <i
            className={
                activeMainMenu === "electricity"
                    ? "fa-solid fa-angle-down sidebar-menu-arrow"
                    : "fa-solid fa-angle-right sidebar-menu-arrow"
            }
        />

    </div>

    <ul
        className={
            activeMainMenu === "electricity"
                ? "sidebar-submenu sidebar-submenu-show"
                : "sidebar-submenu"
        }
    >

        <li className="sidebar-submenu-item">
            <NavLink
                to="/dienluc"
                className={({ isActive }) =>
                    isActive
                        ? "sidebar-submenu-link sidebar-submenu-link-active"
                        : "sidebar-submenu-link"
                }
            >
                Báo cáo cung cấp điện
            </NavLink>
        </li>

        <li className="sidebar-submenu-item">
            <NavLink
                to="/bao-cao-su-co-mat-dien"
                className={({ isActive }) =>
                    isActive
                        ? "sidebar-submenu-link sidebar-submenu-link-active"
                        : "sidebar-submenu-link"
                }
            >
                Báo cáo sự cố, mất điện
            </NavLink>
        </li>

        <li className="sidebar-submenu-item">
            <NavLink
                to="/bao-cao-tiet-kiem-dien"
                className={({ isActive }) =>
                    isActive
                        ? "sidebar-submenu-link sidebar-submenu-link-active"
                        : "sidebar-submenu-link"
                }
            >
                Báo cáo tiết kiệm điện
            </NavLink>
        </li>

        <li className="sidebar-submenu-item">
            <NavLink
                to="/cong-trinh-dien-nong-thon"
                className={({ isActive }) =>
                    isActive
                        ? "sidebar-submenu-link sidebar-submenu-link-active"
                        : "sidebar-submenu-link"
                }
            >
                Công trình điện nông thôn
            </NavLink>
        </li>

        <li className="sidebar-submenu-item">
            <NavLink
                to="/nang-luong-tai-tao-dien"
                className={({ isActive }) =>
                    isActive
                        ? "sidebar-submenu-link sidebar-submenu-link-active"
                        : "sidebar-submenu-link"
                }
            >
                Năng lượng tái tạo
            </NavLink>
        </li>

    </ul>

</li>

{/* Thương mại */}

<li className="sidebar-menu-item">

    <div
        onClick={() => toggleMainMenu("trade")}
        className={
    activeMainMenu === "trade" || isTradeActive
        ? "sidebar-menu-link sidebarMenuLinkActive"
        : "sidebar-menu-link"
}
    >

        <div className="sidebar-menu-left">

            <i className="fa-solid fa-store sidebar-menu-icon"></i>

            <span className="sidebar-menu-text">
                Thương mại
            </span>

        </div>

        <i
            className={
                activeMainMenu === "trade"
                    ? "fa-solid fa-angle-down sidebar-menu-arrow"
                    : "fa-solid fa-angle-right sidebar-menu-arrow"
            }
        />

    </div>

    <ul
        className={
            activeMainMenu === "trade"
                ? "sidebar-submenu sidebar-submenu-show"
                : "sidebar-submenu"
        }
    >

        <li className="sidebar-submenu-item">
            <NavLink
                to="/thuongmai"
                className={({ isActive }) =>
                    isActive
                        ? "sidebar-submenu-link sidebar-submenu-link-active"
                        : "sidebar-submenu-link"
                }
            >
                Báo cáo hoạt động thương mại
            </NavLink>
        </li>

        <li className="sidebar-submenu-item">
            <NavLink
                to="/bao-cao-cho"
                className={({ isActive }) =>
                    isActive
                        ? "sidebar-submenu-link sidebar-submenu-link-active"
                        : "sidebar-submenu-link"
                }
            >
                Báo cáo chợ
            </NavLink>
        </li>

        <li className="sidebar-submenu-item">
            <NavLink
                to="/bao-cao-sieu-thi"
                className={({ isActive }) =>
                    isActive
                        ? "sidebar-submenu-link sidebar-submenu-link-active"
                        : "sidebar-submenu-link"
                }
            >
                Báo cáo siêu thị, TTTM
            </NavLink>
        </li>

        <li className="sidebar-submenu-item">
            <NavLink
                to="/bao-cao-ban-hang-da-cap"
                className={({ isActive }) =>
                    isActive
                        ? "sidebar-submenu-link sidebar-submenu-link-active"
                        : "sidebar-submenu-link"
                }
            >
                Báo cáo bán hàng đa cấp
            </NavLink>
        </li>

        <li className="sidebar-submenu-item">
            <NavLink
                to="/bao-cao-xuc-tien-thuong-mai"
                className={({ isActive }) =>
                    isActive
                        ? "sidebar-submenu-link sidebar-submenu-link-active"
                        : "sidebar-submenu-link"
                }
            >
                Báo cáo xúc tiến thương mại
            </NavLink>
        </li>

        <li className="sidebar-submenu-item">
            <NavLink
                to="/bao-cao-thuong-mai-dien-tu"
                className={({ isActive }) =>
                    isActive
                        ? "sidebar-submenu-link sidebar-submenu-link-active"
                        : "sidebar-submenu-link"
                }
            >
                Báo cáo thương mại điện tử
            </NavLink>
        </li>

    </ul>

</li>

{/* Công nghiệp */}

<li className="sidebar-menu-item">

    <div
        onClick={() => toggleMainMenu("industry")}
        className={
    activeMainMenu === "industry"
        ? "sidebar-menu-link sidebarMenuLinkActive"
        : "sidebar-menu-link"
}
    >

        <div className="sidebar-menu-left">

            <i className="fa-solid fa-industry sidebar-menu-icon"></i>

            <span className="sidebar-menu-text">
                Công nghiệp
            </span>

        </div>

        <i
            className={
                activeMainMenu === "industry"
                    ? "fa-solid fa-angle-down sidebar-menu-arrow"
                    : "fa-solid fa-angle-right sidebar-menu-arrow"
            }
        />

    </div>

    <ul
        className={
            activeMainMenu === "industry"
                ? "sidebar-submenu sidebar-submenu-show"
                : "sidebar-submenu"
        }
    >

        <li className="sidebar-submenu-item">
            <NavLink
                to="/congnghiep"
                className={({ isActive }) =>
                    isActive
                        ? "sidebar-submenu-link sidebar-submenu-link-active"
                        : "sidebar-submenu-link"
                }
            >
                Báo cáo công nghiệp
            </NavLink>
        </li>

        <li className="sidebar-submenu-item">
            <NavLink
                to="/bao-cao-san-xuat"
                className={({ isActive }) =>
                    isActive
                        ? "sidebar-submenu-link sidebar-submenu-link-active"
                        : "sidebar-submenu-link"
                }
            >
                Báo cáo sản xuất công nghiệp
            </NavLink>
        </li>

        <li className="sidebar-submenu-item">
            <NavLink
                to="/bao-cao-cum-cong-nghiep"
                className={({ isActive }) =>
                    isActive
                        ? "sidebar-submenu-link sidebar-submenu-link-active"
                        : "sidebar-submenu-link"
                }
            >
                Báo cáo cụm công nghiệp
            </NavLink>
        </li>

        <li className="sidebar-submenu-item">
            <NavLink
                to="/bao-cao-khuyen-cong"
                className={({ isActive }) =>
                    isActive
                        ? "sidebar-submenu-link sidebar-submenu-link-active"
                        : "sidebar-submenu-link"
                }
            >
                Báo cáo khuyến công
            </NavLink>
        </li>

        <li className="sidebar-submenu-item">
            <NavLink
                to="/bao-cao-co-khi"
                className={({ isActive }) =>
                    isActive
                        ? "sidebar-submenu-link sidebar-submenu-link-active"
                        : "sidebar-submenu-link"
                }
            >
                Báo cáo cơ khí - chế tạo
            </NavLink>
        </li>

    </ul>

</li>

{/* Khuyến công */}
<li className="sidebar-menu-item">
    <NavLink to="/khuyen-cong" className="sidebar-menu-link">
        <div className="sidebar-menu-left">
            <i className="fa-solid fa-handshake sidebar-menu-icon"></i>
            <span className="sidebar-menu-text">Khuyến công</span>
        </div>
    </NavLink>
</li>

{/* Tiêu dùng */}
<li className="sidebar-menu-item">
    <NavLink to="/tieu-dung" className="sidebar-menu-link">
        <div className="sidebar-menu-left">
            <i className="fa-solid fa-cart-shopping sidebar-menu-icon"></i>
            <span className="sidebar-menu-text">Tiêu dùng</span>
        </div>
    </NavLink>
</li>

{/* Quản lý chợ */}
<li className="sidebar-menu-item">
    <NavLink to="/quan-ly-cho" className="sidebar-menu-link">
        <div className="sidebar-menu-left">
            <i className="fa-solid fa-shop sidebar-menu-icon"></i>
            <span className="sidebar-menu-text">Quản lý chợ</span>
        </div>
    </NavLink>
</li>

{/* VLNCN */}
<li className="sidebar-menu-item">
    <NavLink to="/vat-lieu-no" className="sidebar-menu-link">
        <div className="sidebar-menu-left">
            <i className="fa-solid fa-circle-radiation sidebar-menu-icon"></i>
            <span className="sidebar-menu-text">Vật liệu nổ công nghiệp</span>
        </div>
    </NavLink>
</li>

{/* Năng lượng tái tạo */}
<li className="sidebar-menu-item">
    <NavLink to="/nang-luong-tai-tao" className="sidebar-menu-link">
        <div className="sidebar-menu-left">
            <i className="fa-solid fa-solar-panel sidebar-menu-icon"></i>
            <span className="sidebar-menu-text">Năng lượng tái tạo</span>
        </div>
    </NavLink>
</li>

{/* Xuất khẩu */}
<li className="sidebar-menu-item">
    <NavLink to="/xuat-khau" className="sidebar-menu-link">
        <div className="sidebar-menu-left">
            <i className="fa-solid fa-globe sidebar-menu-icon"></i>
            <span className="sidebar-menu-text">Xuất khẩu</span>
        </div>
    </NavLink>
</li>

{/* ATTP */}
<li className="sidebar-menu-item">
    <NavLink to="/an-toan-thuc-pham" className="sidebar-menu-link">
        <div className="sidebar-menu-left">
            <i className="fa-solid fa-heart sidebar-menu-icon"></i>
            <span className="sidebar-menu-text">
                An toàn thực phẩm (CNCT)
            </span>
        </div>
    </NavLink>
</li>

</>
)}

{/* HỒ SƠ */}

<li
    className="sidebar-menu-title sidebar-section-title"
    onClick={() => toggleSection("document")}
>

    <span>HỒ SƠ, VĂN BẢN</span>

    <i
        className={
            openSection === "document"
                ? "fa-solid fa-angle-down"
                : "fa-solid fa-angle-right"
        }
    ></i>

</li>

{
openSection === "document" && (
<>

<li className="sidebar-menu-item">
    <NavLink to="/ho-so-dang-xu-ly"
    className="sidebar-menu-link">
        <div className="sidebar-menu-left">
            <i className="fa-regular fa-folder-open sidebar-menu-icon"></i>
            <span className="sidebar-menu-text">
                Hồ sơ đang xử lý
            </span>
        </div>
    </NavLink>
</li>

<li className="sidebar-menu-item">
    <NavLink to="/ho-so-da-gui"
    className="sidebar-menu-link">
        <div className="sidebar-menu-left">
            <i className="fa-regular fa-folder sidebar-menu-icon"></i>
            <span className="sidebar-menu-text">
                Hồ sơ đã gửi
            </span>
        </div>
    </NavLink>
</li>

<li className="sidebar-menu-item">
    <NavLink to="/van-ban-den"
    className="sidebar-menu-link">
        <div className="sidebar-menu-left">
            <i className="fa-regular fa-file sidebar-menu-icon"></i>
            <span className="sidebar-menu-text">
                Văn bản đến
            </span>
        </div>
    </NavLink>
</li>

<li className="sidebar-menu-item">
    <NavLink to="/van-ban-di"
    className="sidebar-menu-link">
        <div className="sidebar-menu-left">
            <i className="fa-regular fa-paper-plane sidebar-menu-icon"></i>
            <span className="sidebar-menu-text">
                Văn bản đi
            </span>
        </div>
    </NavLink>
</li>

</>
)}

{/* QUẢN LÝ LĨNH VỰC NGÀNH */}
<li className="sidebar-menu-item">

    <div
        onClick={() => toggleMainMenu("fieldSector")}
        className={
    activeMainMenu === "fieldSector" || isFieldSectorActive
        ? "sidebar-menu-link sidebarMenuLinkActive"
        : "sidebar-menu-link"
}
    >

        <div className="sidebar-menu-left">

            <i className="fa-solid fa-layer-group sidebar-menu-icon"></i>

            <span className="sidebar-menu-text">
                Quản lý lĩnh vực ngành
            </span>

        </div>

        <i
            className={
                activeMainMenu === "fieldSector"
                    ? "fa-solid fa-angle-down sidebar-menu-arrow"
                    : "fa-solid fa-angle-right sidebar-menu-arrow"
            }
        />

    </div>

    <ul
        className={
            activeMainMenu === "fieldSector"
                ? "sidebar-submenu sidebar-submenu-show"
                : "sidebar-submenu"
        }
    >

        <li className="sidebar-submenu-item">
            <NavLink
                to="/linh-vuc-nganh"
                className={({ isActive }) =>
                    isActive
                        ? "sidebar-submenu-link sidebar-submenu-link-active"
                        : "sidebar-submenu-link"
                }
            >
                Lĩnh vực ngành
            </NavLink>
        </li>

        <li className="sidebar-submenu-item">
            <NavLink
                to="/nhom-linh-vuc"
                className={({ isActive }) =>
                    isActive
                        ? "sidebar-submenu-link sidebar-submenu-link-active"
                        : "sidebar-submenu-link"
                }
            >
                Nhóm lĩnh vực
            </NavLink>
        </li>

        <li className="sidebar-submenu-item">
            <NavLink
                to="/danh-muc-linh-vuc"
                className={({ isActive }) =>
                    isActive
                        ? "sidebar-submenu-link sidebar-submenu-link-active"
                        : "sidebar-submenu-link"
                }
            >
                Danh mục lĩnh vực
            </NavLink>
        </li>

    </ul>

</li>


{/* QUẢN TRỊ HỆ THỐNG */}
<li className="sidebar-menu-item">

    <div
        onClick={() => toggleMainMenu("admin")}
        className={
    activeMainMenu === "admin" || isSystemAdminActive
        ? "sidebar-menu-link sidebarMenuLinkActive"
        : "sidebar-menu-link"
}
    >

        <div className="sidebar-menu-left">

            <i className="fa-solid fa-screwdriver-wrench sidebar-menu-icon"></i>

            <span className="sidebar-menu-text">
                Quản trị hệ thống
            </span>

        </div>

        <i
    className={
        activeMainMenu === "admin"
            ? "fa-solid fa-angle-up sidebar-menu-arrow"
            : "fa-solid fa-angle-down sidebar-menu-arrow"
    }
></i>

    </div>

</li>

{/* WRAPPER MENU CON */}
{
activeMainMenu === "admin" && (
<ul className="sidebar-admin-wrapper">

                    {/* Quản lý người dùng */}
                    <li className="sidebar-menu-item">

                        <div
    onClick={() => toggleMenu("user")}
    className={
    activeMenu === "user"
        ? "sidebar-menu-link sidebarMenuLinkActive"
        : "sidebar-menu-link"
}
>

                            <div className="sidebar-menu-left">
                                <i className="fa-solid fa-users sidebar-menu-icon"></i>

                                <span className="sidebar-menu-text">
                                    Quản lý người dùng
                                </span>
                            </div>

                            <i className="fa-solid fa-angle-down sidebar-menu-arrow"></i>
                        </div>

                        <ul
    className={
        openMenu === "user"
            ? "sidebar-submenu sidebar-submenu-show"
            : "sidebar-submenu"
    }
>

                            <li className="sidebar-submenu-item">
                                <NavLink
                                    to="/list-user"
                                    className={({ isActive }) =>
                                        isActive
                                            ? "sidebar-submenu-link sidebar-submenu-link-active"
                                            : "sidebar-submenu-link"
                                    }
                                >
                                    Danh sách người dùng
                                </NavLink>
                            </li>

                            <li className="sidebar-submenu-item">
                                <NavLink
                                    to="/group-users"
                                    className={({ isActive }) =>
                                        isActive
                                            ? "sidebar-submenu-link sidebar-submenu-link-active"
                                            : "sidebar-submenu-link"
                                    }
                                >
                                    Nhóm người dùng
                                </NavLink>
                            </li>

                        </ul>

                    </li>

                    {/* Phân quyền */}
                    <li className="sidebar-menu-item">

                        <div
    onClick={() => toggleMenu("role")}
    className={
    activeMenu === "role"
        ? "sidebar-menu-link sidebarMenuLinkActive"
        : "sidebar-menu-link"
}
>

                            <div className="sidebar-menu-left">
                                <i className="fa-solid fa-shield sidebar-menu-icon"></i>

                                <span className="sidebar-menu-text">
                                    Phân quyền
                                </span>
                            </div>

                            <i className="fa-solid fa-angle-down sidebar-menu-arrow"></i>
                        </div>

                        <ul
    className={
        openMenu === "role"
            ? "sidebar-submenu sidebar-submenu-show"
            : "sidebar-submenu"
    }
>

                            <li className="sidebar-submenu-item">
                                <NavLink
    to="/role-groups"
    className={({ isActive }) =>
        isActive
            ? "sidebar-submenu-link sidebar-submenu-link-active"
            : "sidebar-submenu-link"
    }
>
                                    Phân quyền theo nhóm
                                </NavLink>
                            </li>

                            <li className="sidebar-submenu-item">
                                <NavLink
    to="/role-user"
    className={({ isActive }) =>
        isActive
            ? "sidebar-submenu-link sidebar-submenu-link-active"
            : "sidebar-submenu-link"
    }
>
                                    Phân quyền theo người dùng
                                </NavLink>
                            </li>

                        </ul>

                    </li>

                    {/* Quản lý vai trò */}
                    <li className="sidebar-menu-item">

                        <div
    onClick={() => toggleMenu("managerRole")}
    className={
    activeMenu === "managerRole"
        ? "sidebar-menu-link sidebarMenuLinkActive"
        : "sidebar-menu-link"
}
>

                            <div className="sidebar-menu-left">
                                <i className="fa-solid fa-users-gear sidebar-menu-icon"></i>

                                <span className="sidebar-menu-text">
                                    Quản lý vai trò
                                </span>
                            </div>

                            <i className="fa-solid fa-angle-down sidebar-menu-arrow"></i>
                        </div>

                        <ul
    className={
        openMenu === "managerRole"
            ? "sidebar-submenu sidebar-submenu-show"
            : "sidebar-submenu"
    }
>

                            <li className="sidebar-submenu-item">
                                <NavLink
    to="/list-roles"
    className={({ isActive }) =>
        isActive
            ? "sidebar-submenu-link sidebar-submenu-link-active"
            : "sidebar-submenu-link"
    }
>
                                    Danh sách vai trò
                                </NavLink>
                            </li>

                        </ul>

                    </li>

                    {/* Danh mục dùng chung */}
                    <li className="sidebar-menu-item">

                        <div
    onClick={() => toggleMenu("category")}
    className={
    activeMenu === "category"
        ? "sidebar-menu-link sidebarMenuLinkActive"
        : "sidebar-menu-link"
}
>

                            <div className="sidebar-menu-left">
                                <i className="fa-solid fa-server sidebar-menu-icon"></i>

                                <span className="sidebar-menu-text">
                                    Danh mục dùng chung
                                </span>
                            </div>

                            <i className="fa-solid fa-angle-down sidebar-menu-arrow"></i>
                        </div>

                        <ul
    className={
        openMenu === "category"
            ? "sidebar-submenu sidebar-submenu-show"
            : "sidebar-submenu"
    }
>

                            <li className="sidebar-submenu-item">
                                <NavLink
    to="/list-categogy"
    className={({ isActive }) =>
        isActive
            ? "sidebar-submenu-link sidebar-submenu-link-active"
            : "sidebar-submenu-link"
    }
>
                                    Danh sách danh mục
                                </NavLink>
                            </li>

                            <li className="sidebar-submenu-item">
                                <NavLink
    to="/type-categogy"
    className={({ isActive }) =>
        isActive
            ? "sidebar-submenu-link sidebar-submenu-link-active"
            : "sidebar-submenu-link"
    }
>
                                    Loại danh mục
                                </NavLink>
                            </li>

                        </ul>

                    </li>

                    {/* Quản lý dữ liệu */}
                    <li className="sidebar-menu-item">

                        <div
    onClick={() => toggleMenu("data")}
    className={
    activeMenu === "data"
        ? "sidebar-menu-link sidebarMenuLinkActive"
        : "sidebar-menu-link"
}
>

                            <div className="sidebar-menu-left">
                                <i className="fa-solid fa-database sidebar-menu-icon"></i>

                                <span className="sidebar-menu-text">
                                    Quản lý dữ liệu
                                </span>
                            </div>

                            <i className="fa-solid fa-angle-down sidebar-menu-arrow"></i>

                        </div>

                        <ul
    className={
        openMenu === "data"
            ? "sidebar-submenu sidebar-submenu-show"
            : "sidebar-submenu"
    }
>

                            <li className="sidebar-submenu-item">
                                <NavLink
    to="/manager-database"
    className={({ isActive }) =>
        isActive
            ? "sidebar-submenu-link sidebar-submenu-link-active"
            : "sidebar-submenu-link"
    }
>
                                    Quản lý dữ liệu hệ thống
                                </NavLink>
                            </li>

                            <li className="sidebar-submenu-item">
                                <NavLink
    to="/dairy-database"
    className={({ isActive }) =>
        isActive
            ? "sidebar-submenu-link sidebar-submenu-link-active"
            : "sidebar-submenu-link"
    }
>
                                    Nhật ký dữ liệu hệ thống
                                </NavLink>
                            </li>

                        </ul>

                    </li>

                    {/* Tích hợp hệ thống */}
                    <li className="sidebar-menu-item">

                        <div
    onClick={() => toggleMenu("integration")}
    className={
    activeMenu === "integration"
        ? "sidebar-menu-link sidebarMenuLinkActive"
        : "sidebar-menu-link"
}
>

                            <div className="sidebar-menu-left">
                                <i className="fa-solid fa-code-branch sidebar-menu-icon"></i>

                                <span className="sidebar-menu-text">
                                    Tích hợp hệ thống
                                </span>
                            </div>

                            <i className="fa-solid fa-angle-down sidebar-menu-arrow"></i>

                        </div>

                        <ul
    className={
        openMenu === "integration"
            ? "sidebar-submenu sidebar-submenu-show"
            : "sidebar-submenu"
    }
>

                            <li className="sidebar-submenu-item">

                                    <NavLink
    to="/list-integration"
    className={({ isActive }) =>
        isActive
            ? "sidebar-submenu-link sidebar-submenu-link-active"
            : "sidebar-submenu-link"
    }
>
                                    Danh sách tích hợp hệ thống
                                </NavLink>
                            </li>

                            <li className="sidebar-submenu-item">

                                <NavLink
    to="/add-integration"
    className={({ isActive }) =>
        isActive
            ? "sidebar-submenu-link sidebar-submenu-link-active"
            : "sidebar-submenu-link"
    }
>
                                    Thêm cấu hình tích hợp hệ thống
                                </NavLink>
                            </li>

                        </ul>

                    </li>

                    {/* Giám sát hệ thống */}
<li className="sidebar-menu-item">

    <NavLink
        to="/supervision"
        onClick={() => {
            setActiveMenu("supervision");
            setOpenMenu("");
        }}
        className={
            activeMenu === "supervision"
                ? "sidebar-menu-link sidebarMenuLinkActive"
                : "sidebar-menu-link"
        }
    >

        <div className="sidebar-menu-left">

            <i className="fa-regular fa-circle-play sidebar-menu-icon"></i>

            <span className="sidebar-menu-text">
                Giám sát hệ thống
            </span>

        </div>

    </NavLink>

</li>

                    {/* Nhật ký hệ thống */}
                    <li className="sidebar-menu-item">

                        <div
    onClick={() => toggleMenu("diary")}
    className={
    activeMenu === "diary"
        ? "sidebar-menu-link sidebarMenuLinkActive"
        : "sidebar-menu-link"
}
>

                            <div className="sidebar-menu-left">
                                <i className="fa-regular fa-file-lines sidebar-menu-icon"></i>

                                <span className="sidebar-menu-text">
                                    Nhật ký hệ thống
                                </span>
                            </div>

                            <i className="fa-solid fa-angle-down sidebar-menu-arrow"></i>

                        </div>

                        <ul
    className={
        openMenu === "diary"
            ? "sidebar-submenu sidebar-submenu-show"
            : "sidebar-submenu"
    }
>

                            <li className="sidebar-submenu-item">
                                <NavLink
    to="/data-dairy"
    className={({ isActive }) =>
        isActive
            ? "sidebar-submenu-link sidebar-submenu-link-active"
            : "sidebar-submenu-link"
    }
>
                                    Nhật ký dữ liệu hệ thống
                                </NavLink>
                            </li>

                            <li className="sidebar-submenu-item">
                                <NavLink
    to="/action-dairy"
    className={({ isActive }) =>
        isActive
            ? "sidebar-submenu-link sidebar-submenu-link-active"
            : "sidebar-submenu-link"
    }
>
                                    Nhật ký thao tác hệ thống
                                </NavLink>
                            </li>

                        </ul>

                    </li>

                    {/* Sao lưu dữ liệu */}
                    <li className="sidebar-menu-item">

                        <div
    onClick={() => toggleMenu("backup")}
    className={
    activeMenu === "backup"
        ? "sidebar-menu-link sidebarMenuLinkActive"
        : "sidebar-menu-link"
}
>

                            <div className="sidebar-menu-left">
                                <i className="fa-solid fa-upload sidebar-menu-icon"></i>

                                <span className="sidebar-menu-text">
                                    Sao lưu dữ liệu
                                </span>
                            </div>

                            <i className="fa-solid fa-angle-down sidebar-menu-arrow"></i>

                        </div>

                        <ul
    className={
        openMenu === "backup"
            ? "sidebar-submenu sidebar-submenu-show"
            : "sidebar-submenu"
    }
>

                            <li className="sidebar-submenu-item">
                                <NavLink
    to="/list-backup"
    className={({ isActive }) =>
        isActive
            ? "sidebar-submenu-link sidebar-submenu-link-active"
            : "sidebar-submenu-link"
    }
>
                                    Danh sách sao lưu dữ liệu
                                </NavLink>
                            </li>

                            <li className="sidebar-submenu-item">
                                <NavLink
    to="/new-backup"
    className={({ isActive }) =>
        isActive
            ? "sidebar-submenu-link sidebar-submenu-link-active"
            : "sidebar-submenu-link"
    }
>
                                    Tạo sao lưu dữ liệu mới
                                </NavLink>
                            </li>

                            <li className="sidebar-submenu-item">
                                <NavLink
    to="/restore-data"
    className={({ isActive }) =>
        isActive
            ? "sidebar-submenu-link sidebar-submenu-link-active"
            : "sidebar-submenu-link"
    }
>
                                    Khôi phục dữ liệu hệ thống
                                </NavLink>
                            </li>

                        </ul>

                    </li>

                    {/* Cấu hình hệ thống */}
<li className="sidebar-menu-item">

<div
    onClick={() => toggleMenu("config")}
    className={
    activeMenu === "config"
        ? "sidebar-menu-link sidebarMenuLinkActive"
        : "sidebar-menu-link"
}
>

        <div className="sidebar-menu-left">

            <i className="fa-solid fa-gear sidebar-menu-icon"></i>

            <span className="sidebar-menu-text">
                Cấu hình hệ thống
            </span>

        </div>

        <i className="fa-solid fa-angle-down sidebar-menu-arrow"></i>

    </div>

    <ul
    className={
        openMenu === "config"
            ? "sidebar-submenu sidebar-submenu-show"
            : "sidebar-submenu"
    }
>

        <li className="sidebar-submenu-item">
            <NavLink
    to="/noti-share"
    className={({ isActive }) =>
        isActive
            ? "sidebar-submenu-link sidebar-submenu-link-active"
            : "sidebar-submenu-link"
    }
>
                Thông tin chung
            </NavLink>
        </li>

        <li className="sidebar-submenu-item">
            <NavLink
    to="/config-securyti"
    className={({ isActive }) =>
        isActive
            ? "sidebar-submenu-link sidebar-submenu-link-active"
            : "sidebar-submenu-link"
    }
>
                Cấu hình bảo mật
            </NavLink>
        </li>

        <li className="sidebar-submenu-item">
            <NavLink
    to="/config-email"
    className={({ isActive }) =>
        isActive
            ? "sidebar-submenu-link sidebar-submenu-link-active"
            : "sidebar-submenu-link"
    }
>
                Cấu hình Email / SMS
            </NavLink>
        </li>

        <li className="sidebar-submenu-item">
            <NavLink
    to="/config-show"
    className={({ isActive }) =>
        isActive
            ? "sidebar-submenu-link sidebar-submenu-link-active"
            : "sidebar-submenu-link"
    }
>
                Cấu hình hiển thị
            </NavLink>
        </li>
          <li className="sidebar-submenu-item">
            <NavLink
    to="/config-other"
    className={({ isActive }) =>
        isActive
            ? "sidebar-submenu-link sidebar-submenu-link-active"
            : "sidebar-submenu-link"
    }
>
                Cấu hình khác
            </NavLink>
        </li>

    </ul>

</li>

{/* Báo cáo hệ thống */}
<li className="sidebar-menu-item">

    <NavLink
        to="/reports"
        onClick={() => {
            setActiveMenu("report");
            setOpenMenu("");
        }}
        className={
            activeMenu === "report"
                ? "sidebar-menu-link sidebarMenuLinkActive"
                : "sidebar-menu-link"
        }
    >

        <div className="sidebar-menu-left">

            <i className="fa-regular fa-chart-bar sidebar-menu-icon"></i>

            <span className="sidebar-menu-text">
                Báo cáo hệ thống
            </span>

        </div>

    </NavLink>

</li>

</ul>
)}


<div className="sidebar-footer">

    <button className="sidebar-collapse-button">

        <i className="fa-solid fa-angles-left"></i>

        <span>
            Thu gọn menu
        </span>

    </button>

</div>

                </ul>

            </div>

        </div>
        );
    }


export default MenuSibar;